import { Box, Button, Grid, Typography } from "@mui/material";
import { green } from "@mui/material/colors";
import { SlideAnimationContext } from "contexts/SlideAnimation";
import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Map } from "schemas/functions";

import { trackEvent } from "utils/tracking";

import { getOnboardingPage, onboardingNavigate } from "../helper";

const styles = {
  title: { textAlign: "center", mb: 3 },
  mainIcon: { pr: 2, color: "secondary.dark" },
  container: { maxWidth: 650, mb: 2 },
  text: { fontSize: 15 },
  bullet: { listStyleType: "none" },
  verifiedIcon: { pr: 1, color: green[500] },
  pitchIcon: { pr: 1, color: "info.main" },
  followUpIcon: { pr: 1, color: green[700] },
  trackIcon: { pr: 1, color: "primary.main" },
};

const WelcomePage = ({ onboardingForm }: { onboardingForm: Map }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const slideContext = useContext(SlideAnimationContext);

  const handleNext = async () => {
    if (slideContext) {
      await slideContext.slideOutUp();
      slideContext.slideInUp();
    }
    trackEvent("Onboarding Form - Next Button Pressed", {
      page: getOnboardingPage(location.pathname),
      route: location.pathname,
    });

    navigate(
      `/${onboardingNavigate(location.pathname, onboardingForm, "next")}${
        location.search
      }`,
    );
  };

  return (
    <>
      <Typography variant="h3" gutterBottom sx={styles.title}>
        <Box
          component="i"
          sx={styles.mainIcon}
          className="fa-solid fa-hand-wave"
        />
        Welcome to Bento
      </Typography>
      <Box display="flex" justifyContent="center">
        <Box sx={styles.container}>
          <Typography sx={styles.text}>
            Bento makes it easier and faster for content creators to pitch to
            brands by providing:
          </Typography>
          <ul>
            <li style={styles.bullet}>
              <Typography sx={styles.text}>
                <Box
                  component="i"
                  sx={styles.verifiedIcon}
                  className="fa-solid fa-check-double"
                />
                Verified PR Contacts{" "}
              </Typography>
            </li>
            <li style={styles.bullet}>
              <Typography sx={styles.text}>
                <Box
                  component="i"
                  sx={styles.pitchIcon}
                  className="fa-solid fa-wand-magic-sparkles"
                />{" "}
                Pitch Refinement Tools
              </Typography>
            </li>
            <li style={styles.bullet}>
              <Typography sx={styles.text}>
                <Box
                  component="i"
                  sx={styles.followUpIcon}
                  className="fa-solid fa-file-pen"
                />{" "}
                Automated Follow-ups
              </Typography>
            </li>
            <li style={styles.bullet}>
              <Typography sx={styles.text}>
                {" "}
                <Box
                  component="i"
                  sx={styles.trackIcon}
                  className="fa-solid fa-square-kanban"
                />{" "}
                Pitch Tracking
              </Typography>
            </li>
          </ul>
          <Typography sx={styles.text}>
            Ready to land more brand deals?
          </Typography>
        </Box>
      </Box>
      <Grid container justifyContent="center" sx={{ mt: 2 }}>
        <Grid item xs="auto">
          <Button disableElevation variant="contained" onClick={handleNext}>
            Let's Get Started
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default WelcomePage;
